import React from "react";

import Heading from "@common/components/Heading/Heading";
import { formatDayDuration } from "@common/models/helpers/time/dayDuration";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { ReleaseMetricCard, ReleaseMetricCardBaseProps } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";

interface MeanTimeToResolveCardProps extends ReleaseMetricCardBaseProps {
  days: number | null | undefined;
}

const MeanTimeToResolveCard = ({ style, days, score, highlight, error, onMoreClick }: MeanTimeToResolveCardProps) => {
  return (
    <ReleaseMetricCard
      style={style}
      title={"MTTR"}
      score={score}
      highlight={highlight}
      error={error}
      onMoreClick={onMoreClick}
    >
      <Flex $column>
        <Flex style={{ alignItems: "center" }}>
          <Heading
            heading2
            style={{ marginRight: "1.8rem" }}
            marginBottom={0}
          >
            {days != null ? formatDayDuration(days) : "n/a"}
          </Heading>
        </Flex>
      </Flex>
    </ReleaseMetricCard>
  );
};

export { MeanTimeToResolveCard };
